import type { SearchResult } from '../types'
import { storeHighlight } from '../lib/highlight'

interface ResultRowProps {
  result: SearchResult
  query?: string
  isActive?: boolean
  onResultClick?: (url: string) => void
}

function buildTextFragment(result: SearchResult, query: string): string {
  // Find the first ~50-char snippet in content or summary that contains the query
  const lower = query.toLowerCase()
  const sources = [result.content ?? '', result.summary]
  for (const source of sources) {
    const idx = source.toLowerCase().indexOf(lower)
    if (idx !== -1) {
      const snippet = source.slice(Math.max(0, idx - 10), idx + query.length + 40).trim()
      return encodeURIComponent(snippet.slice(0, 60))
    }
  }
  // Fall back to the query itself
  return encodeURIComponent(query)
}

export function ResultRow({ result, query, isActive, onResultClick }: ResultRowProps) {
  function handleClick() {
    onResultClick?.(result.url)
    if (query) storeHighlight(query)
    let url = result.url
    if (query) {
      const fragment = buildTextFragment(result, query)
      url = `${url}#:~:text=${fragment}`
    }
    window.location.href = url
  }

  const displayUrl = result.url.replace(/^https?:\/\//, '')
  const summary =
    result.summary.length > 120 ? result.summary.slice(0, 117) + '…' : result.summary

  return (
    <div
      class={`spotlight-result-row${isActive ? ' spotlight-result-row--active' : ''}`}
      onClick={handleClick}
      role="option"
      aria-label={result.title}
    >
      <div class="spotlight-result-title">{result.title}</div>
      <div class="spotlight-result-summary">{summary}</div>
      <div class="spotlight-result-url">{displayUrl}</div>
    </div>
  )
}
